// export current selected matrix level with rules
export const getCurrentLevel = (state) => state.levels.currentLevel;
// export current selected rule
export const getCurrentRule = (state) => state.currentRule;
// used to open/close ruleTesting
export const showRuleTesting = (state) => state.showRuleTesting;
// used to open/close instance view in rule testing
export const showInstanceTable = (state) => state.showInstanceTable;
// answer after testing rules
export const getTestedRules = (state) => state.testedRules;
export const getBackToDiagram = (state) => state.backToDiagram;
export const getTestAllRules = (state) => state.testAllRules;
export const getSelectedCondition = (state) => state.selectedCondition;
